module.exports = __webpack_public_path__ + "static/media/getFetch.013f0b90.cjs";


//////////////////
// WEBPACK FOOTER
// ./~/i18next-http-backend/esm/getFetch.cjs
// module id = 858
// module chunks = 1